import React from 'react';
import {
  MediaGalleryVideo,
} from '../platformui/';

export default (props) => (
  <MediaGalleryVideo
    {...props}
  />
);
